import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import Global from '../../../../store/global-selectors';

import { ProductDetailsContext } from '../../context';

import style from './style.module.less';
import dropdownStyle from '../../style.module.less';

const defaultCategory = {
  id: 'productDetails.defaultReportingCategory',
  defaultMessage: 'Select One...',
};

export const ReportingCategoryDropdown = () => {
  const { productCategoryId, setProductCategoryId, userHasPermission } = useContext(ProductDetailsContext);
  const productCategories = useSelector(Global.selectEntitiesProductCategories);
  const intl = useIntl();
  const name = productCategories.find((category) => category.categoryId === productCategoryId)?.name ?? '';

  return (
    <DropdownMenu
      className={style['reporting-category-dropdown']}
      disabled={!userHasPermission}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      title={name}
      variant='form'
    >
      <DropdownMenuToggler className={dropdownStyle['dropdown-picker']}>{name || ' '}</DropdownMenuToggler>
      <DropdownMenuItem onClick={() => setProductCategoryId(undefined)}>{intl.formatMessage(defaultCategory)}</DropdownMenuItem>
      {productCategories.map((productCategory) => {
        return (
          <DropdownMenuItem key={productCategory.categoryId} onClick={() => setProductCategoryId(productCategory.categoryId)}>
            {productCategory.name}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};
